import { useState, useEffect } from 'react';
import useMobileDetection from "../../../Hooks/useMobileDetection";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, Box, Switch, FormControlLabel, TextField, Chip, IconButton } from '@mui/material';
import SendIcon from "@mui/icons-material/Send";
import { useSelector, useDispatch } from 'react-redux';
import { dialogButtonConfirm } from "../../../const/DialogData";
import { AutocompleteCustom } from '../../UI/AutoComplete/AutoComplete';
import { getUsersFiltered, addPrenotazioni } from '../../../const/urlAction';
import axios from 'axios';
import handlerError from '../../../functions/handlerError';
import { notificationOpen } from '../../../redux/reducers/notification-reducer';
import { showLoader, hideLoader } from '../../../redux/reducers/appLoader-reducer';
import { saveDataForRiepilogo } from '../../../redux/reducers/RiepilogoDialogAfterPrenotazione-reducer';
import { resetRipetizione } from '../../../redux/reducers/prenotazioneNew-reducer';
import { useTranslation } from 'react-i18next';
import RipetizioniBoxNew from '../Header/RipetizioniBoxNew';
import useGetAvatarUserLogged from '../../../Hooks/UserDate/useGetAvatarUserLogged';
import handlerConfiguration from '../../../functions/general/handlerConfiguration';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCity, faLocationDot, faDoorOpen, faDesktop } from '@fortawesome/free-solid-svg-icons';
import { appRoles } from '../../../const/general/roles';
import { appPolicies } from '../../../const/general/policies';
import MeetingParticipantsSection from '../Common/MeetingParticipantsSection';
const urlBase = process.env.REACT_APP_URL;

export default function DettaglioPrenotazioneNewDialog({ open, onClose, postazione, onBookingSuccess }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useMobileDetection();
    const prenotaNewData = useSelector(state => state.prenotazioneNew);
    const userDate = useSelector(state => state.userDate);
    const configurations = useSelector(state => state.configurations);
    const avatarUserLogged = useGetAvatarUserLogged();
    const { maxGiorniRipetizione, abilitaPrenotazioneMultiplaSalaRiunioni } = handlerConfiguration(configurations);
    const [usersRows, setUsersRows] = useState([]);
    const [isRepeatBookingConfiguredCorrectly, setIsRepeatBookingConfiguredCorrectly] = useState(false);
    const [showOspitiSection, setShowOspitiSection] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [ospiteInput, setOspiteInput] = useState("");
    const [partecipantiRiunioneList, setPartecipantiRiunioneList] = useState([]);
    const [partecipanteInput, setPartecipanteInput] = useState("");
    const [titoloRiunioneInput, setTitoloRiunioneInput] = useState("");
    const [invioNotificaInput, setInvioNotificaInput] = useState(true);

    const {
        selectedDate, selectedStartTime, selectedEndTime, selectedEdificio, selectedStanza,
        ripetizioneStatus, ripetizioneGiorni, ripetizioneDataFine
    } = prenotaNewData;

    const isAdmin = userDate.roles.includes(appRoles.admin);
    const canPolicyBookForOthers = userDate.policies.includes(appPolicies.prenotazionePrenotaPerAltri);
    const hasDelegation = userDate.utenteResponsabileUtenti.length > 0;
    const isBuildingResponsible = userDate.responsabileEdificio?.length > 0;
    const guestEnabled = configurations.configurazioniGlobali.guests.guestEnabled;
    const canBookForOthers =
        (isAdmin || canPolicyBookForOthers || hasDelegation || isBuildingResponsible) &&
        usersRows.length > 1;
    const canBookForGuests = isAdmin || (guestEnabled && canPolicyBookForOthers);
    const maxday = new Date(new Date(Date.now()).setDate(new Date().getDate() + maxGiorniRipetizione));
    const dialogWidth = isMobile ? "100%" : "25%";

    // Utente loggato nel formato compatibile con le opzioni dell'autocomplete
    const loggedUserOption = usersRows.find(u => u.idUtente === userDate.idUtente) || {
        nominativo: userDate.fullName,
        idUtente: userDate.idUtente,
        immagineAvatar: avatarUserLogged,
        ospite: false
    };

    // Carica gli utenti all'apertura e resetta lo stato locale
    useEffect(() => {
        if (open) {
            (async () => {
                const { action, method } = getUsersFiltered;
                let url = urlBase + action;
                try {
                    const response = await axios({ method, url });
                    setUsersRows(response.data.result);
                } catch (error) {
                    console.error(error);
                }
            })();
            resetForm();
        }
    }, [open]);

    // Gestione del checkbox ospiti: se deselezionato, pulisce il nominativo ospite
    const handleOspitiCheckbox = (checked) => {
        setShowOspitiSection(checked);
        if (!checked) {
            setOspiteInput("");
        }
    };

    // Gestione selezione utente nell'autocomplete (singola selezione)
    const handleValueUser = (selectedValue) => {
        setSelectedUser(selectedValue?.idUtente ? selectedValue : null);
    };

    const resetForm = () => {
        setSelectedUser(null);
        setShowOspitiSection(false);
        setOspiteInput("");
        setPartecipantiRiunioneList([]);
        setPartecipanteInput("");
        setTitoloRiunioneInput("");
        setInvioNotificaInput(true);
        dispatch(resetRipetizione());
    };

    const handleConfirm = async () => {
        dispatch(showLoader());

        let prenotazioniArray = [];
        const mainUserId = selectedUser?.idUtente || userDate.id;

        if (showOspitiSection && ospiteInput.trim() !== "") {
            prenotazioniArray.push({
                Utente: mainUserId,
                IdPosto: postazione.id,
                Ospite: true,
                Nominativo: ospiteInput.trim()
            });
        } else {
            prenotazioniArray.push({
                Utente: mainUserId,
                IdPosto: postazione.id,
                Ospite: false,
                Nominativo: null
            });
        }

        const requestBody = {
            prenotazioni: prenotazioniArray,
            disabilitazione: false,
            dataPrenotazione: moment(new Date(selectedDate)).format(),
            oraInizioPrenotazione: moment(new Date(selectedStartTime)).format("HH:mm"),
            oraFinePrenotazione: moment(new Date(selectedEndTime)).format("HH:mm"),
            dataFineRipetizioni: ripetizioneStatus ? moment(new Date(ripetizioneDataFine)).format() : moment(new Date(selectedDate)).format(),
            giorniRipetizione: ripetizioneStatus ? ripetizioneGiorni : [],
            idPostazione: postazione.id
        };

        // Partecipanti sala riunioni
        if (selectedStanza?.isSalaRiunioni) {
            let finalPartecipanti = [...partecipantiRiunioneList];
            if (partecipanteInput.trim() !== "") {
                finalPartecipanti.push(partecipanteInput.trim().toUpperCase());
            }
            if (finalPartecipanti.length > 0) {
                requestBody.partecipantiRiunione = { [postazione.id]: finalPartecipanti };
            }
            if (titoloRiunioneInput.trim() !== "") {
                requestBody.titoloRiunione = { [postazione.id]: titoloRiunioneInput };
            }
            requestBody.invioNotificaInvito = { [postazione.id]: invioNotificaInput };
        }

        const { action, method } = addPrenotazioni;
        try {
            const response = await axios({
                method,
                url: urlBase + action,
                data: requestBody
            });
            if (response.data.ok) {
                dispatch(notificationOpen({ message: response.data.message, status: "success" }));
                dispatch(saveDataForRiepilogo(response.data.result));
                resetForm();
                onClose();
                if (onBookingSuccess) onBookingSuccess();
            } else {
                dispatch(notificationOpen({ message: response.data.message, status: "error" }));
            }
        } catch (error) {
            const errorNotify = handlerError(error);
            dispatch(notificationOpen(errorNotify));
        } finally {
            dispatch(hideLoader());
        }
    };


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: { minWidth: dialogWidth }
            }}>
            <DialogTitle>
                {t("Confirm_booking")}
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                <Grid container spacing={3}>

                    {/* Header: Edificio, Zona, Stanza, Posto */}
                    <Grid item xs={12} sx={{ mb: 1 }}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FontAwesomeIcon icon={faCity} style={{ color: "#3e6bb4", fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: "#3e6bb4" }}>
                                    {selectedEdificio?.sigla?.toUpperCase()}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FontAwesomeIcon icon={faLocationDot} style={{ color: "#3e6bb4", fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: "#3e6bb4" }}>
                                    {prenotaNewData.selectedZona?.sigla?.toUpperCase()}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FontAwesomeIcon icon={faDoorOpen} style={{ color: "#3e6bb4", fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: "#3e6bb4" }}>
                                    {selectedStanza?.sigla?.toUpperCase()}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FontAwesomeIcon icon={faDesktop} style={{ color: "#3e6bb4", fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: "#3e6bb4" }}>
                                    {postazione?.posto || postazione?.id}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    {canBookForOthers && (
                        <>
                            {/* Autocomplete utente */}
                            <Grid item xs={12}>
                                <AutocompleteCustom
                                    label={t("Book_behalf_of")}
                                    field={["nominativo"]}
                                    checkField={"nominativo"}
                                    fullWidth={true}
                                    keyId={"nominativo"}
                                    openOnFocus={true}
                                    optionsAutoComplete={usersRows}
                                    handleValueReturned={handleValueUser}
                                    startValueAutoComplete={loggedUserOption}
                                    multiple={false}
                                />
                            </Grid>

                            {/* Sezione ospiti (singolo ospite, switch + campo testo) — nascosta per sale riunioni */}
                            {canBookForGuests && !selectedStanza?.isSalaRiunioni && (
                                <Grid item xs={12}>
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    onChange={(e) => handleOspitiCheckbox(e.target.checked)}
                                                    checked={showOspitiSection}
                                                />
                                            }
                                            label={t("guests")}
                                        />
                                        {showOspitiSection && (
                                            <TextField
                                                label={t("Guest_Name")}
                                                value={ospiteInput}
                                                onChange={(e) => setOspiteInput(e.target.value)}
                                                variant="standard"
                                                sx={{ flex: 1 }}
                                            />
                                        )}
                                    </Box>
                                </Grid>
                            )}
                        </>
                    )}

                    {/* Ripetizioni: nascoste per sale riunioni (a meno che non sia configurato) */}
                    {(!selectedStanza?.isSalaRiunioni ||
                        (selectedStanza?.isSalaRiunioni && abilitaPrenotazioneMultiplaSalaRiunioni)) && (
                            <Grid item xs={12}>
                                <RipetizioniBoxNew
                                    maxday={maxday}
                                    minDayValue={selectedDate}
                                    isConfiguredCorrectly={setIsRepeatBookingConfiguredCorrectly}
                                />
                            </Grid>
                        )}

                    {/* Sezione Sala Riunioni */}
                    {selectedStanza?.isSalaRiunioni && (
                        <MeetingParticipantsSection
                            titoloRiunione={titoloRiunioneInput}
                            setTitoloRiunione={setTitoloRiunioneInput}
                            invioNotifica={invioNotificaInput}
                            setInvioNotifica={setInvioNotificaInput}
                            participantsList={partecipantiRiunioneList}
                            setParticipantsList={setPartecipantiRiunioneList}
                            partecipanteInput={partecipanteInput}
                            setPartecipanteInput={setPartecipanteInput}
                        />
                    )}
                </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
                <Button onClick={() => {
                    resetForm();
                    onClose();
                }}
                    color="inherit">
                    {t(dialogButtonConfirm.Cancel)}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="primary"
                    disabled={
                        (ripetizioneStatus && !isRepeatBookingConfiguredCorrectly) ||
                        (showOspitiSection && !ospiteInput.trim())
                    }
                >
                    {t(dialogButtonConfirm.Confirm)}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
